module.exports = __webpack_public_path__ + "static/media/YF91_2.b959edba.jpg";